import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex w-full mt-2" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("hr", { class: "border-t-2" })
], -1)
const _hoisted_3 = { class: "mt-2" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("hr", { class: "border-t-2" })
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "mt-2" }, " - ", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("hr", { class: "border-t-2" })
], -1)
const _hoisted_7 = { class: "mt-2" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("hr", { class: "border-t-2" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_DropdownDiscount = _resolveComponent("DropdownDiscount")!
  const _component_ModalForm = _resolveComponent("ModalForm")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_ModalForm, {
      onClose: 
      () => {
        _ctx.onClose();
        _ctx.resetState();
      }
    ,
      onSubmit: _ctx.onOpenSave,
      title: _ctx.$t('posFavourite.editMemberModal.title'),
      isScroll: false,
      isCancelButton: "",
      buttonCancelTitle: _ctx.$t('posFavourite.editMemberModal.cancelButton'),
      buttonTitle: _ctx.$t('posFavourite.editMemberModal.saveButton'),
      modalWidth: "w-6/12"
    }, {
      content: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('posFavourite.editMemberModal.name'),
            class: "w-3/12 mt-4"
          }, {
            default: _withCtx(() => [
              _hoisted_2,
              _createVNode("div", _hoisted_3, _toDisplayString(_ctx.detailCustomer.fullname), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('posFavourite.editMemberModal.address'),
            class: "w-4/12 mt-4"
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _hoisted_5
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('posFavourite.editMemberModal.phone'),
            class: "w-4/12 mt-4"
          }, {
            default: _withCtx(() => [
              _hoisted_6,
              _createVNode("div", _hoisted_7, _toDisplayString(_ctx.detailCustomer.phoneNumber), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('posFavourite.editMemberModal.discount'),
            class: "w-4/12 mt-4"
          }, {
            default: _withCtx(() => [
              _hoisted_8,
              _createVNode(_component_DropdownDiscount, {
                modelValue: _ctx.discountValue,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.discountValue = $event)),
                discountValue: _ctx.members[_ctx.indexMembers].discount,
                "onUpdate:discountValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.members[_ctx.indexMembers].discount = $event)),
                placeholder: _ctx.$t('posFavourite.editMemberModal.select')
              }, null, 8, ["modelValue", "discountValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"])
        ])
      ]),
      _: 1
    }, 8, ["onClose", "onSubmit", "title", "buttonCancelTitle", "buttonTitle"]), [
      [_vShow, _ctx.ModalShow]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx._onEdit,
      onClose: _ctx.onCloseSave,
      title: _ctx.$t('posFavourite.editMemberModal.confirmTitle'),
      message: _ctx.$t('posFavourite.editMemberModal.confirmMessage', { name: _ctx.detailCustomer.fullname }),
      image: "are-you-sure",
      textSuccess: _ctx.$t('posFavourite.editMemberModal.saveButton'),
      textCancel: _ctx.$t('posFavourite.editMemberModal.backButton'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.openSave()]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onCloseSuccess,
      title: _ctx.$t('posFavourite.editMemberModal.successTitle'),
      message: _ctx.$t('posFavourite.editMemberModal.successMessage', { name: _ctx.detailCustomer.fullname }),
      image: "image-modal-success",
      textSuccess: _ctx.$t('posFavourite.editMemberModal.backButton'),
      class: "px-8"
    }, null, 8, ["onSubmit", "title", "message", "textSuccess"]), [
      [_vShow, _ctx.openSuccess]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: _ctx.$t('posFavourite.editMemberModal.exitConfirmTitle'),
      message: _ctx.$t('posFavourite.editMemberModal.exitConfirmMessage'),
      image: "are-you-sure",
      textSuccess: _ctx.$t('posFavourite.editMemberModal.exitButton'),
      textCancel: _ctx.$t('posFavourite.editMemberModal.backButton'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.isEditTerminated]
    ])
  ], 64))
}